import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { SelectedEntity } from "../../Models/SelectedEntity";
import { useDataChanged } from "../Contexts/DataChangedProvider";
import { useEntities } from "../Contexts/EntitiesProvider";
import { useSelectedEntity } from "../Contexts/SelectedEntityProvider";
import "./EntityPicker.css";

export interface Option {
  new_codecompany: string;
  new_entityownerid: string;
  new_name: string;
}

interface EntityPickerProps {
  setSaveOpen: Dispatch<SetStateAction<boolean>>;
}

const EntityPicker = (props: EntityPickerProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const initialRender = useRef(true);
  const { selectedEntity, setSelectedEntity, setPreselectedEntity } =
    useSelectedEntity();
  const { dataChanged } = useDataChanged();
  const { entities } = useEntities();

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (initialRender.current && entities && entities.length > 0) {
      setSelectedEntity(entities[0]);
      initialRender.current = false;
    }
  }, [entities, setSelectedEntity]);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      Budgeting for {currentYear + 1} -
      <div
        className="entityPickerSelector"
        onClick={(e: any) => e.stopPropagation()}
      >
        <div
          className="entityPickerHeader"
          onClick={() => entities && setIsDropdownOpen(!isDropdownOpen)}
        >
          <span>{selectedEntity?.new_name || ""}</span>
          {entities && (
            <img
              className="entityPickerArrow"
              src="Chevron.png"
              alt="chevron"
            />
          )}
        </div>
        {isDropdownOpen && entities && (
          <div className="entityPickerOptions">
            {entities.map((option: Option) => (
              <div
                key={option.new_entityownerid}
                className={`entityPickerOption ${
                  option.new_entityownerid === selectedEntity?.new_entityownerid
                    ? "selected"
                    : ""
                }`}
                onClick={() => {
                  if (dataChanged) {
                    props.setSaveOpen(true);
                    setPreselectedEntity?.(option as SelectedEntity);
                    setIsDropdownOpen(false);
                  } else {
                    setSelectedEntity(option as SelectedEntity);
                    setIsDropdownOpen(false);
                  }
                }}
              >
                {option.new_name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EntityPicker;
